<!--
 * @Author: gvodandan 2388176818@qq.com
 * @Date: 2024-11-26 00:46:53
 * @LastEditors: gvodandan 2388176818@qq.com
 * @LastEditTime: 2024-11-26 00:50:33
 * @FilePath: \no035_HotelManage\vue\src\views\BackToListPage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <el-button plain :size="size" icon="el-icon-back" @click="goBack">{{ `返回${content}列表` }}</el-button>
</template>
  
<script>
export default {
    name: 'BackToListPage',
    props: {
        size: {
            type: String,
            default: 'medium'
        },
        content: {
            type: String,
            default: ''
        },
        to: {
            type: String,
            default: ''
        }
    },
    computed: {
        visitedViews() {
            return this.$store.state.tagsView.visitedViews
        }
    },
    methods: {
        goBack() {
            if (this.to) {
                this.$router.push(this.to)
                return
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>